import { Serializable } from '../../core/models/serializable';

export class CommonLookupItem<TValue, TDisplay>
  implements Serializable<CommonLookupItem<TValue, TDisplay>>
{
  fromObject(obj: any): CommonLookupItem<TValue, TDisplay> {
    Object.assign(this, obj);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public value: TValue;
  public text: TDisplay;

  public isDisabled: boolean;
}

export interface ProviderWebsiteItem {
  value: number;
  text: string;
  isMain: boolean;
}
